export default __webpack_public_path__ + "static/media/default-film.3b92d752.webp";